const TICKET_TYPE_PAY_AS_YOU_GO = 'payAsYouGo';
const TICKET_TYPE_BLOCK_BOOKING = 'blockBooking';
const TICKET_TYPE_SINGLE_EVENT = 'singleEvent';
const TICKET_TYPE_FREE_TRIAL = 'freeTrial';

export {
  TICKET_TYPE_PAY_AS_YOU_GO,
  TICKET_TYPE_BLOCK_BOOKING,
  TICKET_TYPE_SINGLE_EVENT,
  TICKET_TYPE_FREE_TRIAL,
};
